

import { IChangeTracking } from "../../../changeTracking/iChangeTracking";
import { RequestShipment } from "./requestShipment";
import { RequestConsignee } from "./requestConsignee";
import { RequestPickupDetail } from "./requestPickupDetail";

export class RequestDetail implements IChangeTracking {
    private _requestShipment: RequestShipment;
    private _requestConsignee: RequestConsignee;
    private _requestPickupDetail: RequestPickupDetail;
    private _current: any;

    constructor(private _model: any) {
        this._current = this._model ? angular.copy(this._model) : {};
        this._requestShipment = this._current.requestShipment ? new RequestShipment(this._current.requestShipment) : undefined;
        this._requestConsignee = this._current.requestConsignee ? new RequestConsignee(this._current.requestConsignee) : undefined;
        this._requestPickupDetail = this._current.requestPickupDetail ? new RequestPickupDetail(this._current.requestPickupDetail) : undefined;
    }

    get requestShipment(): RequestShipment {
        return this._requestShipment;
    }

    set requestShipment(val: RequestShipment) {
        this._requestShipment = val;
    }

    get requestConsignee(): RequestConsignee {
        return this._requestConsignee;
    }

    set requestConsignee(val: RequestConsignee) {
        this._requestConsignee = val;
    }

    get requestPickupDetail(): RequestPickupDetail {
        return this._requestPickupDetail;
    }

    set requestPickupDetail(val: RequestPickupDetail) {
        this._requestPickupDetail = val;
    }

    hasChanges(): boolean {
        return !angular.equals(this._current, this._model);
    }

    revert(): void {
        this._current = angular.copy(this._model);
    }

    commit(): void {
        this._model = angular.copy(this._current);
    }

    toJson(): any {
        return this._current;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/models/requestDetail.ts
 **/